import {ModalController, NavParams} from '@ionic/angular';
import {Component} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'modal-vacina-error',
    templateUrl: 'modal-vacina-error-component.html',
    styleUrls: ['modal-vacina-error-component.scss']
})

export class ModalVacinaErrorComponent {
    exterior: any;
    infoError = {
        titulo: '',
        mensagem: '',
        imagem: '',
        animacao: '',
    };

    constructor(private modalController: ModalController,
                public router: Router,
                private navParams: NavParams,
    ) {
        this.exterior = this.navParams.get('exterior');
    }

    ionViewDidEnter() {
        if (this.exterior) {
            this.infoError = {
                titulo: 'O Certificado de Vacina da COVID-19 não pode ser emitido com doses aplicadas no exterior.',
                mensagem: 'O Certificado não está disponível para usuários vacinados no exterior, mas você pode emitir a sua <b>Carteira Nacional de Vacinação</b>.',
                imagem: 'assets/imgs/vacina-exterior-erro.svg',
                animacao: 'exterior',
            };
        } else {
            this.infoError = {
                titulo: 'O Certificado de Vacina da COVID-19 não pode ser emitido pois o ciclo vacinal não está completo.',
                mensagem: 'Consulte o cronograma de vacinação da sua região e vacine-se já.',
                imagem: '',
                animacao: 'exterior',
            };
        }
    }

    fechar() {
        this.modalController.dismiss();
    }

    async openVacina() {
        await this.modalController.dismiss();
        localStorage.setItem('tipo_pdf', 'geral');
        await this.router.navigate(['/pdf'], {});
    }

    async openCaminho() {
        await this.modalController.dismiss();
        await this.router.navigate(['/caminho-vacina'], {});
    }
}
